<template>
  <div @click="closeDropdown" class="w-full block sticky top-0 font-primary z-30">
    <div class="flex items-center justify-between px-5 bg-truered transition transition-transform origin-top duration-300 z-50" :class="{ 'scale-y-50 top-0': scrolled}">
      <div class="flex min-h-1/12 justify-left font-primary text-sm transition transition-transform origin-top duration-300" :class="{ 'top-0': scrolled}" >
        <!-- <RouterLink to="/" class="flex flex-col md:flex-row items-start md:items-center justify-start transform-none">
          <img src="./assets/logoPhiphi.png" :class="{ 'scale-x-50': scrolled, 'ml-4': scrolled}" class="p-2 h-32 transition transition-transform origin-left md:origin-right" alt="logo phiphitoys">
        </RouterLink> -->
        <RouterLink to="/catalogo" class="flex flex-col md:flex-row items-start md:items-center justify-start transform-none">
          <img :class="{ 'scale-x-50': scrolled, 'ml-4': scrolled}" class="p-2 h-32 transition transition-transform origin-left md:origin-right" src="./assets/logo.png" alt="logo phiphitoys">
          <img :class="{ 'scale-x-50': scrolled, 'ml-4': scrolled}" class="p-2 h-14 md:h-20 transition transition-transform origin-left" src="./assets/cmmestrellas.png" alt="creando momentos magicos">
        </RouterLink>
      </div>

      <div v-show="isLoggedIn" class="float-none left-auto flex gap-4 items-center transition transition-transform origin-top duration-300" :class="{ 'scale-y-150 scale-y-150 -top-20': scrolled}">
  
        <div class="relative text-left z-99999!important">
          <div @click="openDropdown" class="flex items-center gap-2 cursor-pointer" id="dropdownUserButton" :class="{ 'scale-y-150': scrolled}">
            <img src="./assets/icons/user.png" class="w-8" alt="user-icon">
            <p class="text-white hidden md:block">Hola {{ user.nombre }}</p>
          </div>
          <div :class="{'block': dropdown, 'hidden': !dropdown, 'scale-y-125 translate-y-10': scrolled}" class="absolute right-0 mt-2 bg-white border border-gray-300 rounded-md shadow-lg" style="z-index: 100;" id="dropdownUser">
            <RouterLink to="/mis-pedidos" class="text-xs whitespace-no-wrap block px-2 py-2 text-gray-800 hover:bg-gray-100 rounded-md">MIS PEDIDOS</RouterLink>
            <RouterLink to="/catalogos" class="text-xs whitespace-no-wrap block px-2 py-2 text-gray-800 hover:bg-gray-100">CATÁLOGOS</RouterLink>
            <RouterLink to="/olvide-mi-contrasena"  class="text-xs whitespace-no-wrap block px-2 py-2 text-gray-800 hover:bg-gray-100">CAMBIAR CONTRASEÑA</RouterLink>
            <RouterLink v-if="user.tipo != 'cliente'" to="/importar-pedido" class="text-xs whitespace-no-wrap block px-2 py-2 text-gray-800 hover:bg-gray-100">IMPORTAR PEDIDO</RouterLink>
            <RouterLink v-if="user.tipo == 'admin' || user.tipo == 'supervisor'" to="/consulta"  class="z-100 text-xs whitespace-no-wrap block px-2 py-2 text-gray-800 hover:bg-gray-100">CONSULTA ARTICULOS</RouterLink>
            <RouterLink v-if="user.tipo == 'admin'" to="/admin"  class="z-100 text-xs whitespace-no-wrap block px-2 py-2 text-gray-800 hover:bg-gray-100">ADMIN</RouterLink>
            <button @click="handleLogout" class="w-full text-xs whitespace-no-wrap block py-2 text-gray-800 hover:bg-gray-100">CERRAR SESIÓN</button>
          </div>
        </div>
  
        <RouterLink to="/carrito" class="flex items-center gap-2" :class="{ 'scale-y-125': scrolled}">
          <img src="./assets/icons/shopping-cart.png" class="w-7" alt="user-icon">
          <p class="text-white hidden md:block">({{ itemsCarrito }} ITEMS)</p>
        </RouterLink>
  
      </div>
    </div>
    <div v-show="isLoggedIn && anuncioInformativo != {} && anuncioInformativo.color" class="flex transition md:px-5 transition-transform origin-top duration-300 " :class="{'md:-translate-y-16 -translate-y-20': scrolled}">
      <div class="w-full relative rounded-md block sticky top-0 mt-1" :class="{'border': anuncioInformativo != {} && anuncioInformativo != null}" :style="{backgroundColor: anuncioInformativo.color, color: anuncioInformativo.colorTexto}">
        <img @click="anuncioInformativo = {}" class="hover:cursor-pointer h-1/3 absolute top-1/3 right-3" src="./assets/icons/error.png" alt="">
        <p class="font-bold">{{ anuncioInformativo.titulo }}</p>
        <p>{{ anuncioInformativo.texto }}</p>
      </div>
    </div>
    <div class="w-full flex justify-center">
      <Alert v-if="isAlertVisible"
      :message="alertMessage"
      :success="alertSuccess"
      @close="closeAlert()"/>
    </div>
  </div>
  <router-view/>
  <footer class="w-full flex flex-wrap bg-truered h-60 sm:h-44 md:h-20 p-2 align-center items-center justify-around mt-14">
    <div class="flex gap-1 items-center flex-wrap">
      <a href="http://charko.com.ar" target="_blank" rel="noopener noreferrer"><img class="h-14" src="./assets/charko.png" alt=""></a>
      <img class="h-16 p-2" src="./assets/logos_en_blanco.png" alt="">
    </div>
    <div class="flex gap-2 items-center flex-wrap">
      <p class="text-white">Phi Phi Toys© {{ new Date().getFullYear() }}. Todos los derechos reservados.</p>  
      <a target="_blank" href="https://qr.afip.gob.ar/?qr=OdP9vzdyYqQbafAgShcj1w,,"><img class="h-10" src="./assets/data-fiscal.jpg" alt="data fiscal"></a>
    </div>
  </footer>
</template>

<script>
import { defineComponent } from 'vue';
import store from './store/index'
import router from './router'
import pedidosService from './services/pedidos.service';
import configService from './services/config.service';
import Alert from '@/components/Alert.vue'
import _debounce from 'lodash/debounce'


export default defineComponent({
    data() {
      return {
        buscador: '',
        user: {},
        itemsCarrito: 0,
        isAlertVisible: false,
        alertMessage: "Realizado con exito",
        alertSuccess: true,
        anuncioInformativo: {},
        scrolled: false,
        dropdown: false
      }
    },
    components: {
      Alert
    },
    setup() {
      const handleLogout = () => {
        document.getElementById('dropdownUser').classList.add('hidden')
        store.dispatch('auth/logout').then(() => {
          router.push('/login')
        })
      }
      return {
        handleLogout
      }
    },
    mounted() {
      if (this.isLoggedIn) {
        this.$nextTick(() => {
          this.user = JSON.parse(localStorage.getItem('user'))
          this.getCarrito()
          this.getAnuncio()
        });
        // buscar items del carrito
      }
    },
    created() {
      this.scrolled = window.scrollY > 1;
      window.addEventListener('scroll', _debounce(this.handleScroll, 5));
    },
    beforeUnmount() {
      window.removeEventListener('scroll', this.handleScroll);
    },
    methods: {
      closeDropdown() {
        if (this.dropdown) {
        this.dropdown = false
        }
        console.log(this.dropdown)
      },
      openDropdown() {
        if (this.dropdown) {
          this.dropdown = false
        } else {
          setTimeout(() => {
            console.log('dropdown')
            this.dropdown = true
            console.log(this.dropdown)
          },300)
        }
      },
      handleScroll() {
        this.scrolled = window.scrollY > 0;
      },
      closeAlert() {
        this.isAlertVisible = false
      },
      getCarrito() {
        pedidosService.getCountItemsCarrito(this.user.id)
          .then((res) => {
            this.itemsCarrito = res.data
          })
          .catch((err) => {
            console.log(err)
          })
      },
      getAnuncio() {
        configService.getAnuncio()
          .then((res) => {
            if (res.data != '') {
              var clr = (res.data.split(';')[2] ? res.data.split(';')[2] : 'white')
              this.anuncioInformativo = {
                titulo: res.data.split(';')[0],
                texto: res.data.split(';')[1].split('|')[0],
                colorTexto: res.data.split(';')[1].split('|')[1],
                color: clr
              }

            }
          })
          .catch(err => {
            console.log(err)
          })
      },
      inicialize() {
        if (this.isLoggedIn) {
          this.$nextTick(() => {
            this.user = JSON.parse(localStorage.getItem('user'))
            if (this.user) {
              this.getCarrito()
              this.getAnuncio()
            }
          });
          // buscar items del carrito
        }
      }
    },
    computed: {
      isLoggedIn() {
        return this.$store.state.auth.status.loggedIn && JSON.parse(localStorage.getItem('user'))
      }
    }
})

document.addEventListener('DOMContentLoaded', function () {
    const dropdownButton = document.getElementById('dropdownUserButton');
    const dropdownMenu = document.getElementById('dropdownUser');

    dropdownButton.addEventListener('click', function () {
      console.log('mostrar menu')
      dropdownMenu.classList.toggle('hidden');
      dropdownMenu.classList.add('z-100');
    });

    // Close the dropdown when clicking outside
    document.addEventListener('click', function (event) {
      if (!dropdownButton.contains(event.target)) {
        dropdownMenu.classList.add('hidden');
      }
    });
  });
</script>

<style>
#app {
  /* -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale; */
  text-align: center;
  /* color: #2c3e50; */
}

iframe#webpack-dev-server-client-overlay{display:none!important}

nav {
  padding: 30px;
}

nav a {
  font-weight: bold;
  color: #2c3e50;
}

nav a.router-link-exact-active {
  color: #42b983;
}
</style>
